export default __webpack_public_path__ + "static/media/choose-out.456522dc.mp3";